import React from 'react';

import { UiButton } from '../../../ui/ui-button';
import { UiDialog } from '../../../ui/ui-dialog';

import Message from '../../../widgets/legacy-message';

export const ActionBlockedForResponsivenessMessage = ({
  onClose,
  job,
  variant,
  action,
}: {
  onClose: (action: 'turn off' | 'revert' | 'delete' | null) => void;
  job?: Job;
  variant: 'dialog' | 'warning';
  action: 'turn off' | 'delete' | 'revert';
}) => {
  const warningText = `${
    job ? 'This job' : 'One or more of your jobs'
  } uses the Responsive filter for applicants
  which requires at least one active interest confirmation. If you would like to ${action} this
  interest confirmation, ${
    job
      ? 'please turn on or create another interest confirmation first'
      : 'you will have to turn on another interest confirmation for those jobs first'
  }.`;

  const handleCloseDialog = () => onClose(null);

  return variant === 'dialog' ? (
    <UiDialog onClose={handleCloseDialog} title="Cannot Turn Off Automation">
      <UiDialog.Content>
        <div>{warningText}</div>
      </UiDialog.Content>
      <UiDialog.Actions>
        <UiButton onClick={handleCloseDialog}>Okay</UiButton>
      </UiDialog.Actions>
    </UiDialog>
  ) : (
    <Message variant="error" canBeDismissed onMessageDismissed={handleCloseDialog}>
      {warningText}
    </Message>
  );
};
